import React from 'react';
import { useSelector } from 'react-redux';

import { EnergyLabel } from '@ao-internal/components-react';

import { useIsLargeAndAbove } from '../../../hooks/mediaQueries';

const EnergyLabelSvg = ({ energyRatingDetails, is2020Label, classes }) => {
	const {
		EnergyRating,
		EnergyRatingLabelUrl,
		MaxEnergyRating,
	} = energyRatingDetails;

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const isLargeAndAbove = useIsLargeAndAbove();

	if (!EnergyRating) {
		return null;
	}

	const energyRatingArray = EnergyRating?.split('/');

	return (
		<EnergyLabel
			data-testid="energy-rating-link-updated-component"
			href={EnergyRatingLabelUrl}
			rating={energyRatingArray}
			highestRating={MaxEnergyRating}
			className={`text-base cursor-pointer z-10 relative ${classes}`}
			use2020Label={is2020Label}
			modalProps={{ className: 'energy-label-modal ' }}
			reverse={CustomCategoriesEnabled && isLargeAndAbove}
		/>
	);
};

export default EnergyLabelSvg;
